<template>
  <v-row class="text-center">
    <v-col cols="10" md="4" sm="8" offset-md="4" offset-sm="2" offset="1">
      <v-img :src="upperLogo" alt="Welcome to Harlequin" class="mx-auto" />
      <v-card>
        <v-toolbar
          color="#f87723"
          dark
        >Welcome To Harlequin | {{ serverName }}</v-toolbar>
        <v-card-text>
          <v-form>
            <div class="pt-5">Please log in below</div>

            <v-text-field
              v-if="(!samlEnabled && !msalEnabled) || hqadmin"
              v-model="username"
              :prepend-icon="'mdi-account'"
              :type="'text'"
              :rules="[rules.required]"
              name="username"
              label="Username"
              autocomplete="new-password"
            ></v-text-field>

            <v-text-field
              v-if="(!samlEnabled && !msalEnabled) || hqadmin"
              v-model="password"
              :prepend-icon="'mdi-lock'"
              :append-icon="showPass ? 'mdi-eye-off' : 'mdi-eye'"
              :type="showPass ? 'text' : 'password'"
              :rules="[rules.required]"
              name="password"
              label="Password"
              autocomplete="new-password"
              @click:append="showPass = !showPass"
            ></v-text-field>
            <div v-if="ssoLoginFailed" class="red--text">{{ ssoLoginError }}</div>
            <div v-if="loginFailed" class="red--text">Username or password incorrect</div>
            <div v-if="licenseExpired" class="red--text">{{ licenseError }}</div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-col class="text-center">
            <v-btn
              large
              dark
              color="#f87723"
              @click="login({value})"
              :loading="loggingIn"
            >Login</v-btn>
          </v-col>
        </v-card-actions>
        <v-col class="text-center">
          <div><a @click="requestReset()">Forgotten Password</a></div>
        </v-col>
      </v-card>
      <v-img :src="lowerLogo" alt="Welcome to Harlequin" class="mx-auto rsl-logo" />
    </v-col>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="400"
      v-model="resetDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ $t('GENERAL.PW_RESET_TITLE') }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ $t('GENERAL.PW_RESET_TEXT') }}</div>
            <v-form v-model="isFormValid" ref="resetRequestForm">
              <v-text-field
                v-model="resetId"
                :prepend-icon="'mdi-account'"
                :type="'text'"
                :rules="[rules.required]"
                name="username"
                label="Username"
                autocomplete="new-password"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="resetDialog = false"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="confirmResetRequest()"
              :disabled="!isFormValid"
            >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </v-row>

</template>

<script>
import * as msal from '@azure/msal-browser';
import { mapGetters } from 'vuex';
export default {
    name: 'login',
    computed: mapGetters(['loggedInUser', 'licenseStartDate', 'licenseExpiryDate', 'ssoDetails', 'ssoUserAdded', 'ldapAuthSuccess', 'ldapUserNotExist']),
    data: function() {
        return {
          loggingIn: false,
          isFormValid: false,
          upperLogo: '',
          lowerLogo: '',
          username: null,
          password: null,
          showPass: false,
          value: null,
          loginFailed: false,
          licenseExpired: false,
          licenseError: '',
          serverName: '',
          msalEnabled: false,
          samlEnabled: false,
          ldapEnabled: false,
          ssoLoginFailed: false,
          ssoLoginError: '',
          ssoPayload: {},
          hqadmin: false,
          rules: {
            required: value => !!value || 'Required'
          },
          resetDialog: false,
          resetId: null
        }
    },
    created() {
      this.unsubscribe = this.$store.subscribe((mutation) => {

        // Listen for SSO user creation
        if(mutation.type === 'SSO_USER_ADDED') {
          if(this.ssoUserAdded) {
            this.ssoLogin(this.ssoPayload);
          }
        }

        if(mutation.type === 'SSO_DETAILS') {
          if(this.ssoDetails.msalEnabled) {
            this.msalEnabled = true;
          }
          if(this.ssoDetails.samlEnabled) {
            this.samlEnabled = true;
            const urlParams = new URL(window.location.toLocaleString()).searchParams;

            if(urlParams.has('isAuthenticated')) {
              let samlAuth = urlParams.get('isAuthenticated');

              if(samlAuth) {
                let username = urlParams.get('samlEmail').split('@');
                let uname = username[0].replaceAll(/[^a-zA-Z0-9]/g, '');

                let fname = urlParams.get('samlFirstname');
                let sname = urlParams.get('samlLastname');

                this.ssoPayload = {'samlUsername': urlParams.get('samlEmail'), 'username': uname, 'name': fname + ' ' + sname};
                this.ssoLogin(this.ssoPayload);
              }
            }
          }
          if(this.ssoDetails.ldapEnabled && this.ssoDetails.ldapLoginEnabled) {
            this.ldapEnabled = true;
          }
        }

        if(mutation.type === 'LDAP_AUTH_SUCCESS') {
          if(this.ldapAuthSuccess){
            let hqUsername = this.username;
            if(hqUsername.includes("\\")) {
              hqUsername = hqUsername.split('\\')[1];
            }
            hqUsername = hqUsername.replace(/[^A-Z0-9]/ig, "");

            let payload = {'username': hqUsername, 'password': this.password};
            this.ssoLogin(payload);
          }else{
            this.ssoLoginError = 'LDAP login failed. Attempting local login...';
            this.ssoLoginFailed = true;
            this.standardLogin();
          }
        }

        if(mutation.type === 'LDAP_USER_NOT_EXIST') {
          this.ssoLoginError = this.ldapUserNotExist;
          this.ssoLoginFailed = true;
          this.standardLogin();
        }

      });

      this.$store.dispatch('getSsoDetails');

      if(this.$route.query.hqadmin) {
        this.hqadmin = true;
      }
    },
    beforeDestroy() {
      this.unsubscribe();
    },
    mounted() {
      // Set logos
      this.upperLogo = process.env.VUE_APP_UPPER_IMAGE;
      this.lowerLogo = process.env.VUE_APP_LOWER_IMAGE;

      // Add negative tabindex to icons
      let icons = document.querySelectorAll('.v-icon');
      
      for(let v = 0; v < icons.length; v++) {
        icons[v].setAttribute('tabindex', -1);
      }
      
      // Set server name
      this.serverName = process.env.VUE_APP_SERVER_NAME;
      document.getElementById('main-title').innerHTML = "Harlequin | " + this.serverName;
    },
    methods: {
      async login () {
        this.loggingIn = true;
        await this.$store.dispatch('getLicense').then( async () => {
          let sDate = new Date(this.licenseStartDate);
          let eDate = new Date(this.licenseExpiryDate);
          let today = new Date();
          this.licenseExpired = true;
            
          if(today.getTime() <= eDate.getTime() && today.getTime() >= sDate.getTime()) {
              this.licenseExpired = false;
          }else if(today.getTime() < sDate.getTime()) {
            this.licenseError = "Your license has not yet started. It will become active on " + sDate;
          }else {
            this.licenseError = "Your license expired on " + eDate;
          }
          
          if(this.msalEnabled && !this.licenseExpired && this.username != 'hqadmin') {
            this.$store.commit('MSAL_SSO_ENABLED', true);

            // Config object to be passed to MSAL on creation
            const msalConfig = {
              auth: {
                clientId: this.ssoDetails.msalClientId,
                authority: this.ssoDetails.msalAuthority,
                redirectUri: this.ssoDetails.msalRedirectUri
              },
              cache: {
                cacheLocation: "sessionStorage", // This configures where your cache will be stored
                storeAuthStateInCookie: this.ssoDetails.msalAuthState // Set this to "true" if you are having issues on IE11 or Edge
              }
            };

            const msalObj = new msal.PublicClientApplication(msalConfig);
            this.$store.commit('MSAL_CONFIG', msalConfig);
            
            const loginScope = {
              scope: ["User.read"]
            }

            msalObj.loginPopup(loginScope).then(response => {
              msalObj.setActiveAccount(response.account);
              this.$store.commit('MSAL_ACTIVE_ACCOUNT', response.account);
              let username = response.account.username.split('@');
              let uname = username[0].replaceAll(/[^a-zA-Z0-9]/g, '');
              this.ssoPayload = {'msalUsername': response.account.username, 'username': uname, 'name': response.account.name};
              this.ssoLogin(this.ssoPayload);
            }).catch(error => {
              this.ssoLoginFailed = true;
              this.ssoLoginError = error;
            });
          }

          if(this.samlEnabled && !this.licenseExpired && this.username != 'hqadmin') {
            this.$store.commit('SAML_SSO_ENABLED', true);
            let samlUrl = window.location.origin + '/saml/login.jsp';
            window.location.replace(samlUrl);
          }

          if(this.ldapEnabled && !this.licenseExpired && this.username != 'hqadmin') {
            this.$store.commit('LDAP_ENABLED', true);
            let payload = {'username': this.username, 'password': this.password};
            this.$store.dispatch('ldapLogin', payload);
          }

          if((!this.msalEnabled && !this.samlEnabled && !this.ldapEnabled && !this.licenseExpired) || this.username == 'hqadmin') {
            let payload = {'username': this.username, 'password': this.password};
            await this.$store.dispatch('login', payload)
              .then(() => {
                this.loggingIn = false;
                if(this.loggedInUser.authenticated){
                  this.updateLog('Admin', 'Login', 'User ' + this.username + ' logged in.');

                  this.$router.push('/dashboard');
                }else{
                  this.loginFailed = true;
                }
              });
          }
        });
      },
      async ssoLogin(payload) {
        this.$store.dispatch('completeSsoLogin', payload)
          .then(() => {
            this.loggingIn = false;
            if(this.loggedInUser.authenticated){
              this.updateLog('Admin', 'Login', 'User ' + payload.username + ' logged in.');

              this.$router.push('/dashboard');
            }else{
              this.ssoLoginFailed = true;
            }
          });
      },
      async standardLogin() {
        // Used only to attempt local login if LDAP enabled and login fails (might be a standard user)
        let payload = {'username': this.username, 'password': this.password};
        await this.$store.dispatch('login', payload)
          .then(() => {
            this.loggingIn = false;
            if(this.loggedInUser.authenticated){
              this.updateLog('Admin', 'Login', 'User ' + this.username + ' logged in.');

              this.$router.push('/dashboard');
            }else{
              this.loginFailed = true;
            }
          });
      },
      requestReset() {
        this.resetDialog = true;
      },
      confirmResetRequest() {
        this.resetDialog = false;
        this.$store.dispatch('createLookupKey', this.resetId).then( () => {
          this.resetId = null;
          this.isFormValid = false;
          this.$refs.resetRequestForm.resetValidation();
        });
      },
      updateLog(cat, op, msg) {
        let dt = new Date();
        let dateTime = new Intl.DateTimeFormat('en-GB', 
          {
            day: 'numeric',
            month: 'numeric', 
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false
          }).format(dt);

        let logData = {
          'category': cat,
          'userId': this.username,
          'caseId': 0,
          'processName': null,
          'taskName': null,
          'operation': op,
          'msg': msg,
          'dateTime': dateTime,
        };
        this.$store.dispatch('updateOpLog', logData);
      }
    }
}
</script>

<style>
  .v-main,
  .bkgd-black {
    background-color: #1b1b1b;
  }
  .rsl-logo {
    max-width: 305px;
  }
  .rsl-fixed-height {
    height: calc(100vh - 100px);
    overflow: auto;
  }
</style>
